import { env } from "../env";

const PROJECT_ID = "wgonwvvibu";

let initialized = false;
let initializing: Promise<void> | null = null;

export function initClarity() {
  if (initialized || initializing) {
    return;
  }

  if (env.VITE_VERCEL_ENV !== "production") {
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  initializing = import("@microsoft/clarity")
    .then(({ default: Clarity }) => {
      if (initialized) {
        return;
      }

      Clarity.init(PROJECT_ID);
      initialized = true;
    })
    .finally(() => {
      initializing = null;
    });
}
